import { on } from "@ember-decorators/object"
import { getOwner } from "@ember/application"
import Component from "@ember/component"

export default class RouteWatcher extends Component {
  @on("didReceiveAttrs")
  watchForRoute({ oldAttrs, newAttrs }) {
    if (
      oldAttrs !== undefined &&
      newAttrs !== undefined &&
      (oldAttrs.route.value !== newAttrs.route.value ||
        oldAttrs.routeModels.value !== newAttrs.routeModels.value ||
        oldAttrs.routeParams.value !== newAttrs.routeParams.value) &&
      newAttrs.route.value !== undefined
    ) {
      getOwner(this)
        .lookup("router:main")
        .transitionTo(newAttrs.route.value, newAttrs.routeModels.value, newAttrs.routeParams.value)
    }
  }
}
